import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { vodList } from '@/network/apis/apiUri';
import { logEvent } from 'firebase/analytics';
import NavData from '@/config/data/nav/nav_data.json';
import analytics from '../../../../firebase';
import { MainHead } from '../common';

export default function ProgramVod(props) {
  const { mode, history, selBoard } = props;

  const firstRender = useRef(true);

  const [listData, setListData] = useState();
  const [pageInfo, setPageInfo] = useState();

  const [loading, setLoading] = useState(true);

  const handleMoreBtn = () => {
    const searchParams = new URLSearchParams(history.location.search);
    const nowPage = searchParams.get('page') ?? 1;

    searchParams.set('page', Number(nowPage) + 1);

    history.push(`?${searchParams.toString()}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams(history.location.search);

    const formData = new FormData(e.currentTarget);

    const searchOpt = formData.get('searchOpt');
    const searchText = formData.get('searchText') ?? '';

    if (searchOpt) searchParams.set('searchOpt', searchOpt);
    if (searchText) searchParams.set('searchText', searchText);
    else searchParams.delete('searchText');
    searchParams.delete('page');

    history.push(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    setLoading(true);

    const searchParams = new URLSearchParams(history.location.search);
    const page = searchParams.get('page') ?? 1;
    const searchOpt = searchParams.get('searchOpt') ?? null;
    const searchText = searchParams.get('searchText') ?? null;

    vodList({
      board_id: selBoard.boardId,
      type: 'vod',
      lan_code: mode,
      key_word: searchText ? searchOpt : null,
      word: searchText,
      page_info: {
        row_count: firstRender.current ? 8 * page : 8,
        number: firstRender.current ? 0 : page - 1,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          const _pageInfo = res.data.paging_info;
          const _data = res.data.item.map((el) => ({
            key: `vod_${el.board_item_id}`,
            itemId: el.board_item_id,
            vodId: el.vod_id,
            broadDate: el.broadcast_date ? el.broadcast_date.slice(0, 10) : '',
            regDate: el.reg_date ? el.reg_date.slice(0, 10) : '',
            title: el.title,
            content: el.content,
            image: el.image_url,
          }));
          setPageInfo(_pageInfo);

          if (_data.length) setListData((prev) => (searchParams.get('page') && prev ? [...prev, ..._data] : _data));
          else setListData(undefined);
        } else {
          setListData(undefined);
          setPageInfo(undefined);
        }
      })
      // .catch((e) => console.loerg(e))
      .finally(() => setLoading(false));

    if (firstRender.current) firstRender.current = false;
  }, [history.location]);

  return (
    <div id="CommonProgramVod" className="commonProgramVod">
      <section className="commonProgramVod_section">
        <MainHead title={selBoard.title} mode={mode} handleSubmit={handleSubmit} />
        {!listData && loading && (
          <div className="loading-wrap">
            <img
              className="loading"
              src={require('../../../../../assets/images/common/loading.png').default}
              alt="loading_img"
            />
            <p>now Loading...</p>
          </div>
        )}
        <div className="commonProgramVod_section_content">
          <ul className="list-wrap">
            {listData &&
              listData.map((el) => (
                <li className="list" key={el.key}>
                  <Link
                    to={`${NavData['RADIO_MAIN'].path}/${selBoard.programId}/vod?id=${el.vodId}&board=${selBoard.boardId}&sort=vod`}
                    className="list_link"
                    onClick={() =>
                      logEvent(analytics, 'select_item', {
                        item_list_name: `${el.title}`,
                        item_list_id: `vod_${el.vodId}`,
                        items: [
                          {
                            item_id: `${el.vodId}`,
                            item_name: `${el.title}`,
                            item_brand: 'vod',
                          },
                        ],
                      })
                    }
                  >
                    <div className="list_img">
                      <img
                        className="img"
                        src={el.image}
                        alt={el.title}
                        onError={(e) =>
                          (e.target.src = require('../../../../../assets/images/common/672_379_A.png').default)
                        }
                      />
                    </div>
                    <div className="list_title-wrap style_0">
                      <h3 className="list_title">{el.title}</h3>
                      <span className="list_date time-fs-fixed">{el.broadDate}</span>
                    </div>
                    <p className="list_sub"></p>
                  </Link>
                </li>
              ))}
          </ul>
          {pageInfo && pageInfo.total_item_count > listData?.length && (
            <div className="btnMore-wrap">
              <button type="button" className="btnMore" onClick={handleMoreBtn}>
                More
              </button>
            </div>
          )}
          {!listData && !loading && (
            <div className="alert" style={{ textAlign: 'center' }}>
              <img
                className="alert_img"
                src={require('../../../../../assets/images/icon/ico_alert.png').default}
                alt="There is no VOD yet"
              />
              <p className="alert_text">There is no VOD yet</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
